// extracted by mini-css-extract-plugin
export var version = "css-module--version--d4159";